<template>
  <div class="mt-8">
    <div class="flex gap-x-5 w-full">
      <Input
        v-if="driverComment?.typeDeleted ?? false"
        :model-value="driverComment?.typeText ?? ''"
        :label="$t('pages.driver.historyList.modal.fields.type')"
        class="w-1/2"
        :disabled="true"
      />
      <Multiselect
        v-else
        v-model="driverComment.type"
        :error="errors?.type"
        :options="driverCommentTypes"
        :label="$t('pages.driver.historyList.modal.fields.type')"
        class="w-1/2"
        :can-deselect="false"
        :can-clear="false"
        :searchable="true"
      />
<!--      <Multiselect-->
<!--        v-model="driverComment.author"-->
<!--        :error="errors?.author"-->
<!--        :options="driverCommentAuthors"-->
<!--        :label="$t('pages.driver.historyList.modal.fields.employee')"-->
<!--        class="w-1/2"-->
<!--        :can-deselect="false"-->
<!--        :can-clear="false"-->
<!--        :searchable="true"-->
<!--      />-->
      <Input
        v-if="driverComment?.id !== undefined"
        :model-value="driverComment.author ?? ''"
        :label="$t('pages.driver.historyList.modal.fields.employee')"
        class="w-1/2"
        :disabled="true"
      />
    </div>
    <div class="flex gap-x-5 w-full mt-7.5">
      <text-area
        v-model="driverComment.text"
        :error="errors?.text"
        :label="$t('pages.driver.historyList.modal.fields.text')"
        class="w-full"
      />
    </div>
    <div v-if="driverComment.createdAt !== undefined" class="flex gap-x-5 w-full mt-7.5">
      <date-picker
        v-model="driverComment.createdAt"
        :error="errors?.text"
        :label="$t('pages.driver.historyList.modal.fields.createdAt')"
        mode="dateTime"
      />
    </div>
    <div class="flex gap-x-5 w-full mt-7.5">
      <!-- TODO: Multi-File-Upload -->
      <Files
        v-model="internalFiles"
        class="w-full"
        with-button
        @click="emit('openFiles')"
      />
    </div>
    <div class="w-full text-center">
      <custom-button
        variant="primary"
        class="mt-15"
        :busy="loading"
        @click="emit('save')"
      >
        {{ $t("save") }}
      </custom-button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import CustomButton from '@utils/CustomButton.vue';
import TextArea from '@utils/inputs/TextArea.vue';
import Multiselect from '@utils/Multiselect.vue';
import DatePicker from '@components/utils/inputs/DatePicker.vue';
import { useVModel } from '@vueuse/core';
import { collOptionsProvider } from '@utils/table/hooks/provider';
import Files from '@utils/inputs/Files.vue';
import Input from '@utils/inputs/Input.vue';
import type {
  DriverComment, DriverCommentType, User, WbFile,
} from '@/entities/Entities';
import type { FileUpload } from '@/components/utils/upload/fileUpload';

interface Props {
  modelValue: Partial<DriverComment>;
  files: FileUpload<WbFile>[];
  loading: boolean;
  errors?: Record<string, unknown> | undefined;
}

const emit = defineEmits(['update:modelValue', 'update:files', 'save', 'openFiles']);
const props = defineProps<Props>();

const driverComment = useVModel(props, 'modelValue', emit);
const internalFiles = useVModel(props, 'files', emit, { passive: true });

const driverCommentTypes = collOptionsProvider<DriverCommentType>(
  '/driver_comment_types',
  {
    filter: {
      deleted: false,
    },
    sort: {
      sortKey: 'text',
      sortDirection: 'ASC',
    },
  },
  (value) => ({
    label: value.text,
    value: value['@id'],
  }),
);

const driverCommentAuthors = collOptionsProvider<User>('/admins', {}, (value) => ({
  label: value.fullName,
  value: value['@id'],
}));
</script>

<style lang="scss" scoped></style>
